export default "__VITE_ASSET__bd324743__"